import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

import authReset from '../../lib/authReset'
import authSendWelcomeMail from '../../lib/authSendWelcomeMail'

export function getName(){
  return 'content'
}

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var columns = [
    {
      id: 'view',
      value: item.view,
      type: o.type.text,
    },
    {
      id: 'de',
      value: item.de,
      type: o.type.markdown,
      width: 300,
      multiline: true,
    },
    {
      id: 'en',
      value: item.en,
      type: o.type.markdown,
      width: 300,
      multiline: true,
    },
    {
      id: 'fr',
      value: item.fr,
      type: o.type.markdown,
      width: 300,
      multiline: true,
    },
    {
      id: 'ru',
      value: item.ru,
      type: o.type.markdown,
      width: 300,
      multiline: true,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.content,

      function(item){

        var model = o.model.content
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            o.edit.set(item,model)
          }

        return {

          columns: columns,
          click: click,

        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  var fields = [
    {
      id: 'view',
      value: item.view,
      type: 'text',
    },
    {
      id: 'de',
      value: item.de,
      type: 'markdown',
      edit: true,
    },
    {
      id: 'en',
      value: item.en,
      type: 'markdown',
      edit: true,
    },
    {
      id: 'fr',
      value: item.fr,
      type: 'markdown',
      edit: true,
    },
    {
      id: 'ru',
      value: item.ru,
      type: 'markdown',
      edit: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.content
  var collection = 'content'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var data = o.data.content
  var collection = 'content'

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.content
  var collection = 'content'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/content/content.js